import { mapRange } from '@wix/wow-utils';
import { getTimingFactor, toKeyframeValue } from '../../utils';
const TRANSLATE_KEYFRAMES = [{
  keyframe: 17,
  translate: 7
}, {
  keyframe: 32,
  translate: 25
}, {
  keyframe: 48,
  translate: 8
}, {
  keyframe: 56,
  translate: 11
}, {
  keyframe: 66,
  translate: 25
}, {
  keyframe: 83,
  translate: 4
}, {
  keyframe: 100,
  translate: 0
}];
const POWER_TO_POKE_FACTOR_MAP = {
  soft: 1,
  medium: 2,
  hard: 4
};
const DIRECTION_MAP = {
  top: {
    x: 0,
    y: -1
  },
  bottom: {
    x: 0,
    y: 1
  },
  right: {
    x: 1,
    y: 0
  },
  left: {
    x: -1,
    y: 0
  }
};
export function web(options, _dom) {
  return style(options, true);
}
export function style(options, asWeb) {
  if (asWeb === void 0) {
    asWeb = false;
  }
  const {
    power,
    intensity = 0.5,
    direction = 'right'
  } = options.namedEffect;
  const duration = options.duration || 1;
  const delay = +(options.delay || 0);
  const {
    x,
    y
  } = DIRECTION_MAP[direction];
  const timingFactor = getTimingFactor(duration, delay);
  const [name] = getNames(options);
  const responsivePokeFactor = mapRange(0, 1, POWER_TO_POKE_FACTOR_MAP.soft, POWER_TO_POKE_FACTOR_MAP.hard, intensity);
  const pokeFactor = power ? POWER_TO_POKE_FACTOR_MAP[power] : responsivePokeFactor;

  // Create CSS custom properties for the poke configuration
  const custom = {
    '--motion-translate-x': x * pokeFactor,
    '--motion-translate-y': y * pokeFactor
  };
  const keyframes = TRANSLATE_KEYFRAMES.map(_ref => {
    let {
      keyframe,
      translate
    } = _ref;
    const translateValue = `calc(${toKeyframeValue(custom, '--motion-translate-x', asWeb)} * ${translate}px) calc(${toKeyframeValue(custom, '--motion-translate-y', asWeb)} * ${translate}px)`;
    return {
      offset: keyframe / 100 * timingFactor,
      translate: translateValue
    };
  });
  return [{
    ...options,
    name,
    easing: 'linear',
    delay: 0,
    duration: duration + delay,
    custom,
    keyframes
  }];
}
export function getNames(options) {
  const timingFactor = getTimingFactor(options.duration, options.delay, true);
  return [`motion-poke-${timingFactor}`];
}
//# sourceMappingURL=Poke.js.map